import OwnerRoute from "../common/components/OwnerRoute";
import ProjectSettings from "../settings/pages/ProjectSettings";

const settingsRoutes = [
  {
    path: "settings",
    element: (
      <OwnerRoute>
        <ProjectSettings />
      </OwnerRoute>
    ),
  },
];

export default settingsRoutes;
